export default {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  SET_BREADCRUMB: 'SET_BREADCRUMB',
  CLEAR_BREADCRUMB: 'CLEAR_BREADCRUMB'
}
